import keyMirror from 'keymirror';

export default keyMirror({
  API: null,
  SET_ACCESS_ERROR_TYPE: null,
  FILL_PENDING_BLOCK_LIST: null,
  CHANGE_SURVEY_SETTING: null,
  SET_ADD_BLOCK_NETWORK_PENDING_STATUS: null,
  CLEAR_PENDING_BLOCK_LIST: null,
  CLEAR_NETWORK_PENDING_ORDER_MAP: null,
  START_REMOVE_BLOCK: null,
  DELETE_BLOCK: null,
  REPLACE_SURVEY_BLOCK: null,
  FINISH_REMOVE_BLOCK: null,
  SET_USER: null,
  INSERT_BLOCK: null,
  SET_SHARE_URL_SLUG: null,
  SET_EDITOR_ACTIVE_SURVEY: null,
  SET_TIMEZONE_OPTIONS: null,
  SET_LATEST_ADDED_BLOCK_CLIENT_UUID: null,
  SET_SURVEY_LIST_SORT_ORDER: null,
  SET_SURVEY_LIST_SORT_BY: null,
  SET_SURVEY_LIST_FILTER: null,
  SET_SURVEY_LIST_CURRENT_TAB: null,
  SET_SURVEY_LIST_SEARCH_TEXT: null,
  SET_SURVEY_LIST_SURVEYS: null,
  SET_SURVEY_SEARCH_PREVIEW_TEXT: null,
  SET_SURVEY_SEARCH_PREVIEW_SURVEYS: null,
  SET_QUESTION_NUMBERS: null,
  SET_VISITED_QUESTION_NUMBERS: null,
  SET_OVERWRITE_CUSTOM_STYLES: null,
  ADD_SURVEY_SEARCH_PREVIEW_SURVEYS: null,
  SET_SURVEY_SEARCH_PREVIEW_SURVEY_COUNT: null,
  SET_IS_SURVEY_SEARCH_PREVIEW_IN_PROGRESS: null,
  ADD_NEW_NOT_PERSISTED_BLOCK_UUID: null,
  REMOVE_NEW_NOT_PERSISTED_BLOCK_UUID: null,
  ADD_MODIFIED_NEW_NOT_PERSISTED_BLOCK_UUID: null,
  REMOVE_MODIFIED_NEW_NOT_PERSISTED_BLOCK_UUID: null,
  SET_ACTIVE_BLOCK_CLIENT_UUID: null,
  SET_ACTIVE_BLOCK_TOUCHED_FLAG: null,
  SET_IS_ACTIVE_BLOCK_LOGIC_PANEL_OPENED: null,
  SET_SURVEY_LIST_SURVEYS_META: null,
  ADD_SELECTED_SURVEY_ID: null,
  REMOVE_SELECTED_SURVEY_ID: null,
  SELECT_ALL_SURVEY_IDS: null,
  DESELECT_ALL_SURVEY_IDS: null,
  SET_LANDING_PAGE_ENABLED_STATE: null,
  SET_THANK_YOU_PAGE_ENABLED_STATE: null,
  SET_REDIRECT_URL: null,
  SET_NETWORK_PENDING_ORDER_MAP: null,
  SET_NETWORK_PENDING_ORDER_MAP_STATUS: null,
  SORT_SECTION_BLOCK_LIST_BY_ORDER_MAP: null,
  MOVE_BLOCK: null,
  UPDATE_BLOCK: null,
  UPDATE_BLOCK_REQUEST: null,
  PERSIST_BLOCK_UPDATE_REQUEST: null,
  START_UPDATE_BLOCK_LIST: null,
  FINISH_UPDATE_BLOCK_LIST: null,
  UPDATE_BLOCK_LIST_BULK: null,
  UPDATE_ORDER_MAP: null,
  UPDATE_SURVEY_LIST_ITEM: null,
  UPDATE_SURVEY_LIST_ITEM_IS_FAVORITE: null,
  CLEAR_SURVEY_SECTION: null,
  SET_EDITOR_ACTIVE_SECTION: null,
  SET_SURVEY_LIST_LOADING_STATE: null,
  SET_EDITOR_LOADING_STATE: null,
  SET_EDITOR_SURVEY_NAME: null,
  SET_SURVEY_LIST_PAGE_COUNT: null,
  SET_SURVEY_LIST_CURRENT_PAGE: null,
  REMOVE_UNSAVED_BLOCK_LIST: null,
  RETURN_UNDELETE_BLOCK_LIST: null,
  SET_SECTION_HEADERS: null,
  UPDATE_SECTION_HEADER: null,
  UPDATE_SECTION_HEADERS: null,
  CLEAR_SECTION_HEADERS: null,
  CLEAR_SECTION_HEADER: null,
  SET_SECTION_HEADER: null,
  SET_SHARED_HEADER: null,
  SET_IS_SURVEY_NAME_FOCUSED: null,
  SET_POST_SURVEY_LOGIC: null,
  RESET_POST_SURVEY_LOGIC: null,
  SET_POST_LOGIC_QUESTION_ID: null,
  ADD_POST_LOGIC_RULE: null,
  SET_POST_LOGIC_RULE: null,
  REMOVE_POST_LOGIC_RULE: null,
  ADD_POST_LOGIC_ITEM: null,
  REMOVE_POST_LOGIC_ITEM: null,
  TOGGLE_POST_LOGIC_ITEM: null,
  RESET_POST_LOGIC_RULE: null,
  // Drag & Drop constants
  BEGIN_DRAG: null,
  END_DRAG: null,
  // Drag & Drop constants end here
  // Block data cache
  CACHE_BLOCK_DATA: null,
  REMOVE_CACHED_BLOCK_DATA: null,
  TOGGLE_SURVEY_FULL_WIDTH: null,
  GET_SURVEYS_REQUEST: null,
  GET_SURVEY_NAMES_REQUEST: null,
  CHANGE_EDIT_SURVEY_STATUS: null,
  UPDATE_EDIT_SURVEY_STATUS: null,
  SET_SURVEY_STATUS_PENDING_STATE: null,
  FINISH_HEADER_PERSISTENCE: null,
  FINISH_BLOCK_ORDER_PERSISTENCE: null,
  SET_SURVEY_HEADER_END_ENABLED: null,
  SET_SURVEY_HEADER_LANDING_ENABLED: null,
  SET_SURVEY_HEADER_QUESTIONS_ENABLED: null,
  SET_SURVEY_BACK_BUTTON_ENABLED: null,
  // Feature Flags
  SET_FEATURE_FLAG: null,
});
